import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"
import { Creators as ProfileCreators } from "model/profileModal"
import { getSelectedDate, getEarliestDate, getLatestDate, getStartDate, getEndDate, getDriftDates } from "modules/security-profile/selectors/dates"
import { getFilteredData, getCategoryItemsSubset, getRiskAttribution } from "./selectors/data"
import { getOptions } from "./selectors/options"
import { getDisplayType } from "./selectors/items"
import { computePositionSet } from "modules/security-profile/helpers/security"
import { getFirstRiskDate, getMaxFactors } from "./selectors/risk"
import { getDetails } from "./selectors/details"

export default createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
    startDate: getStartDate(state),
    endDate: getEndDate(state),
    selectedDate: getSelectedDate(state),
    driftDates: getDriftDates(state),
  }),
  data: [{
    resource: "securityRiskHistory",
    url: ({ modelId, security: { assetClass, ticker, mic, modelProviderId }, base, driftDates, startDate, endDate }) => {
      const from = startDate < driftDates.startDate ? startDate : driftDates.startDate
      const to = driftDates.endDate

      if (base) {
        if (!base.type) {
          base = {
            dates: [{
              date: from,
              ...base,
            }],
          }
        }
      }

      return {
        id: `securityRiskHistory-${modelId}${ticker}${mic}${startDate}${endDate}${JSON.stringify(base)}`,
        query: `query ($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $from: Date!, $to: Date!) {
          model (id: $modelId) {
            simulation(positionSet: $positionSet, base: $base, from: $from, to: $to, interval: AUTO) {
              risk {
                date,
                total,
                attribution {
                  summary {
                    factors,
                    specific
                  }
                  factors {
                    id
                    category
                    name
                    value
                  }
                }
              }
            }
          }
        }`,
        variables: {
          modelId,
          positionSet: {
            dates: [{
              date: startDate,
              ...computePositionSet(assetClass, ticker, mic, modelProviderId),
            }],
          },
          base,
          from,
          to,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    earliestDate: getEarliestDate(state),
    latestDate: getLatestDate(state),
    data: getFilteredData(state),
    items: getCategoryItemsSubset(state),
    displayType: getDisplayType(state),
    firstDate: getFirstRiskDate(state),
    options: getOptions(state),
    details: getDetails(state),
    riskAttribution: getRiskAttribution(state, props),
    maxFactors: getMaxFactors(state, props),
    ...state.modules.securityProfileRisk,
  }),
  actions: {
    setDate: PortfolioRootCreators.setProfileDate,
    resetDate: PortfolioRootCreators.resetProfileDate,
    openFactorProfile: ProfileCreators.openFactorProfile,
    ...Creators,
  },
})
